<template>
  <!-- Client only to avoid hydration errors. No impact for seo since the hreflang is set in the head -->
  <ClientOnly>
    <ul
      v-if="alternates.length > 1"
      class="relative flex items-start gap-4"
    >
      <li v-for="alternate in alternates" :key="alternate.locale">
        <button
          type="button"
          class="uppercase typo-body-xl"
          :class="{ 'underline underline-offset-[6px]': currentLocale === alternate.locale }"
          @click="switchLanguage(alternate.locale)"
        >
          {{ getLocaleLanguage(alternate.locale) }}
        </button>
      </li>
    </ul>
  </ClientOnly>
</template>

<script setup lang="ts">
defineProps<{
  size?: 'sm' | 'md'
}>()

const switchLocalePath = useSwitchLocalePath()
const { locale: currentLocale, locales, localeProperties } = useI18n()
const entry = inject(EntryInjectionKey, null)
const route = useRoute()

type Alternate = {
  locale: string
  url?: string

}

const alternates = computed<Alternate[]>(() => {
  if (Array.isArray(entry?.value?.alternates)) {
    // We have an entry from statamic
    return entry.value.alternates.filter(e => !!e) as Alternate[]
  } else {
    // We do not have an entry from statamic, likely using nuxt pages instead, so we offer all available locales
    return locales.value.filter(l => !l.isBusinessReport).map((l) => {
      return {
        locale: l.code,
      }
    })
  }
})

function switchLanguage(event: any) {
  const selectedLocale = event
  if (Array.isArray(alternates.value) && alternates.value.length) {
    const url = alternates.value.find(a => a.locale === selectedLocale)?.url

    if (url && url !== route.path) {
      switchLocalePath(selectedLocale) // this is needed to work with different domains for different languages
      return navigateTo(url, {
        external: true,
      })
    }
  }

  navigateTo(switchLocalePath(selectedLocale), {
    external: true, // this is needed to work with different domains for different languages
  })
}

function getLocaleLanguage(locale: string) {
  const localeObj = locales.value.find(l => l.iso === locale)
  return localeObj ? localeObj.language : ''
}
</script>
